export const detectMobileDevice = () => {
    if (typeof window === "undefined")
        return false;
    const userAgent = navigator.userAgent;
    if (!userAgent)
        return false;
    const mobileRegex = /android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i;
    const isMobileUserAgent = mobileRegex.test(userAgent.toLowerCase());
    return isMobileUserAgent;
};
